import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Aims from './components/Aims';
import Outcomes from './components/Outcomes';
import Events from './components/Events';
import EventDetails from './components/EventDetails';
import Gallery from './components/Gallery';
import Help from './components/Help';
import Donate from './components/Donate';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add the ScrollToTop component */}
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/event/:eventId" element={<EventDetailsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Separate page components for better routing
const HomePage = () => (
  <>
    <Hero />
    <About />
    <Aims />
    <Outcomes />
    <Gallery />
    <Help />
    <Donate />
  </>
);

const EventsPage = () => <Events />;

const EventDetailsPage = () => <EventDetails />;

export default App;